@if (loading) {
  <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
    <p-progress-spinner ariaLabel="loading" />
  </div>
} @else {
  <h5 class="mb-3">{{ translations.document_list }}</h5>

  @if (documents.length > 0) {
    @for (document of documents; track document.title + document.creationDt) {
      <div class="p-3 mb-2 bg-light border">
        <div>
          <strong>Title:</strong>
          {{ document.title }}
        </div>

        <div>
          <strong>Creation Date:</strong>
          {{ document.creationDt }}
        </div>

        <div class="mt-3 d-flex gap-2">
          @if (document.pdfDocument) {
            <button
              type="button"
              class="btn btn-info"
              (click)="printPdf(document.pdfDocument)"
            >
              {{ translations.print }}
            </button>
          }

          @if (document.cdaDocument) {
            <button
              type="button"
              class="btn btn-primary"
              (click)="displayCda(document.cdaDocument)"
            >
              {{ translations.display }}
            </button>
          }
        </div>
      </div>
    }
  } @else {
    <div class="alert alert-info">
      {{ translations.ps_error }}
    </div>
  }

  @if (documentLoading) {
    <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
      <p-progress-spinner ariaLabel="loading" />
    </div>
  }

  @if (pdfUrl) {
    <embed
      [src]="pdfUrl"
      type="application/pdf"
      width="100%"
      height="1050px"
    />
  }

  @if (htmlUrl) {
    <iframe
      [src]="htmlUrl"
      width="100%"
      height="1050px"
    ></iframe>
  }
}
